import { render, staticRenderFns } from "./StickyAddButton.vue?vue&type=template&id=68fa8f12&scoped=true&"
import script from "./StickyAddButton.vue?vue&type=script&lang=js&"
export * from "./StickyAddButton.vue?vue&type=script&lang=js&"
import style0 from "./StickyAddButton.vue?vue&type=style&index=0&id=68fa8f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa8f12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
